import { primeUiLicense } from './prime-ui-license';

export const environment = {
    production: false,
    blueBird: false,
      apiUrl: "https://api-test.careaudits.co.uk/",
      primeUiLicense
      //apiUrl: "https://localhost:7266/"
  };
